import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "D:/_FREELANCE/20241219_MrFrancois_BagheraAdvisory/baghera-advisory-landing/node_modules/.pnpm/@unhead+vue@2.1.2_vue@3.5.26_typescript@5.7.2_/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}